import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import NewUserView from "./new-user-view";
import { resetNewUser } from "./new-user-actions";
import Utils from "../../library/utils";

class ResetConfirm extends Component {
  constructor(props) {
    super(props);

    const params = new URLSearchParams(location.search);
    const guid = params.get("guid");

    this.state = {
      firstName: "",
      lastName: "",
      password: "",
      confirmPassword: "",
      detailsSetSuccessfully: false,
      guid
    };
  }

  onChangeFirstName = e => {
    this.setState({ firstName: e.target.value });
  };

  onChangeLastName = e => {
    this.setState({ lastName: e.target.value });
  };

  onChangePassword = e => {
    this.setState({ password: e.target.value });
  };

  onChangeConfirmPassword = e => {
    this.setState({ confirmPassword: e.target.value });
  };

  resetNewUser = () => {
    const { password, firstName, lastName, guid } = this.state;
    const payload = {
      firstName,
      lastName,
      guid,
      password
    };
    this.props.resetNewUser(payload, success => {
      if (success) {
        this.setState({ detailsSetSuccessfully: true });
      }
    });
  };

  handleKeyDown = e => {
    if (e.key === "Enter") {
      this.resetNewUser();
    }
  };

  render() {
    const {
      password,
      confirmPassword,
      firstName,
      lastName,
      detailsSetSuccessfully
    } = this.state;
    return (
      <NewUserView
        {...this.props}
        resetNewUser={this.resetNewUser}
        password={password}
        confirmPassword={confirmPassword}
        firstName={firstName}
        lastName={lastName}
        onChangeFirstName={this.onChangeFirstName}
        onChangeLastName={this.onChangeLastName}
        onChangePassword={this.onChangePassword}
        onChangeConfirmPassword={this.onChangeConfirmPassword}
        disabled={
          _.isEmpty(firstName) ||
          _.isEmpty(lastName) ||
          !Utils.isValidPassword(password) ||
          !Utils.isValidPassword(confirmPassword) ||
          password !== confirmPassword
        }
        handleKeyDown={this.handleKeyDown}
        detailsSetSuccessfully={detailsSetSuccessfully}
      />
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth
});

const mapDispatchToProps = {
  resetNewUser: resetNewUser
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetConfirm);



// WEBPACK FOOTER //
// ./src/components/new-user/new-user.js